import {
  GetRecyclingRequestsRequestParams,
  PutRecyclingRequestRequestBody,
} from '@/src/apis/rest/recyclingRequests.dtos';
import request from '../axios';
import { ListResponse, ObjectResponse } from '@/src/types/common';
import { plainToInstance } from 'class-transformer';
import {
  RecyclingRefreshStatusDto,
  RecyclingRequestDto,
} from '@/src/models/RecyclingRequestDto';

const URL = {
  recyclingRequests: '/admin/recycling-requests',
  recyclingRequestsDetail: '/admin/recycling-requests/{id}',
  recyclingRequestsExcel: '/admin/recycling-requests/excel-export',
  recyclingRefresh: '/admin/recycling-requests/refresh-status',
  recyclingCheckInprogress: '/admin/recycling-requests/in-progress/{id}',
};

export const getRecyclingRequestsAPI = async (
  requestParams: Partial<GetRecyclingRequestsRequestParams>,
) => {
  const { page = 1, pageSize = 10, ...rest } = requestParams;

  const { data } = await request<ListResponse<RecyclingRequestDto>>({
    method: 'get',
    url: URL.recyclingRequests,
    queryParams: { ...rest, page, pageSize },
  });

  const rows = plainToInstance(RecyclingRequestDto, data.rows);

  return { rows, count: data.count };
};

export const getRecyclingStatusRefreshAPI = async () => {
  const { data } = await request<ObjectResponse<RecyclingRefreshStatusDto>>({
    method: 'get',
    url: URL.recyclingRefresh,
  });

  return plainToInstance(RecyclingRefreshStatusDto, data.row);
};

export const getRecyclingRequestsByIdAPI = async (id: number) => {
  const { data } = await request<ObjectResponse<RecyclingRequestDto>>({
    method: 'get',
    url: URL.recyclingRequestsDetail.replace('{id}', String(id)),
  });

  return plainToInstance(RecyclingRequestDto, data.row);
};

export const getRecyclingRequestsCheckInprogressAPI = async (id: number) => {
  const { data } = await request<ObjectResponse<RecyclingRequestDto>>({
    method: 'get',
    url: URL.recyclingCheckInprogress.replace('{id}', String(id)),
  });

  return plainToInstance(RecyclingRequestDto, data.row);
};

export const getRecyclingRequestsExcelAPI = async (
  password: string,
  requestParams: Partial<GetRecyclingRequestsRequestParams>,
) => {
  const { data } = await request<Blob>({
    method: 'get',
    url: URL.recyclingRequestsExcel,
    queryParams: { ...requestParams, password },
    config: { responseType: 'blob' },
  });

  return data;
};

export const putRecyclingRequestAPI = async (
  id: number,
  // requestBody: PutRecyclingRequestRequestBody,
) => {
  const { data } = await request<ObjectResponse<RecyclingRequestDto>>({
    method: 'put',
    url: URL.recyclingRequestsDetail.replace('{id}', String(id)),
    // requestBody,
  });

  return plainToInstance(RecyclingRequestDto, data.row);
};
